<template>
  <div v-if="line" id="activityOutlookSync" class="p-mb-2" :class="{ 'p-invalid': line.error }">
    <i class="pi pi-calendar p-mr-1" /> {{ line.text }}
  </div>
</template>

<script>
import OutlookSyncService from '@/service/OutlookSyncService'
import { activityLine } from './outlookSync'

// On a task or event's page: where it is in Outlook, as the server words it. No status, a 404 or any failure: no line.
export default {
  props: { activityId: { type: [Number, String], default: null } },
  data: () => ({ sync: null }),
  computed: {
    line() { return activityLine(this.sync) }
  },
  watch: {
    activityId: { immediate: true, handler: 'load' }
  },
  methods: {
    load() {
      this.sync = null
      if (this.activityId === null || this.activityId === undefined || this.activityId === '') return Promise.resolve()
      if (!this.outlookSyncService) this.outlookSyncService = new OutlookSyncService()
      const asked = this.activityId
      return this.outlookSyncService.activityStatus(asked)
        .then(sync => { if (asked === this.activityId) this.sync = sync })
        .catch(() => { this.sync = null })
    }
  }
}
</script>
